<template>
    <div class="thankyou_page " id="flight-result-wrapper">

        <div class="tq-wrapper">
            <section class="main">
                <div class="row">
                    <div class="col-md-6 action-img">
                        <img v-if="bookingStatus=='SuccessPage'" src="@imgPath/img/svg/img/succes-img.svg" alt="">
                        <img v-if="bookingStatus=='FailedPage'" src="@imgPath/img/svg/img/failed.svg" alt="">
                        <img v-if="bookingStatus=='HoldPage'" class="blue-to-orange"
                             src="@imgPath/img/svg/img/hold.svg" alt="">
                        <img v-if="bookingStatus=='PendingPage'" src="@imgPath/img/svg/img/pending.svg" alt="">
                    </div>
                    <!--                    hold for 'hold'-->
                    <!--                    pending for 'pending'-->
                    <!--                    success for 'success'-->
                    <!--                    falied for 'falied'-->

                    <div :class="bookingStatus=='SuccessPage'?'col-md-6 book-details success':
                    bookingStatus=='FailedPage'?'col-md-6 book-details failed':
                    bookingStatus=='HoldPage'?'col-md-6 book-details hold':
                    'col-md-6 book-details pending'">
                        <div class="title-main">
                        
                    
                    <span>
                        {{$t("bookingStatus.yourFlight")}}
                    </span>
                            <span>
                        {{bookingStatus=='SuccessPage'?$t("bookingStatus.success"):bookingStatus=='FailedPage'?
                        $t("bookingStatus.failed"):bookingStatus=='PendingPage'?$t("bookingStatus.pending"):
                        $t("bookingStatus.hold")}}
                            </span>
                        </div>

                        <!-- (If it is failed page) -->
                        <div v-if="bookingStatus=='FailedPage'" class="container-title">
                            {{$t("bookingStatus.sessExp")}}
                        </div>
                        <div v-if="bookingStatus=='FailedPage'" class="col-md-6">
                            <div class="content-section">
                            
                             <span v-if="orderDetails && orderDetails.error">
                              {{$t("bookingStatus.code")}}  {{' '+orderDetails && orderDetails.error && orderDetails.error[0].code}}
                            </span>
                            </div>
                        </div>

                        <!-- (No need to show orderId,pnr,ticketingDeadline for failed page) -->
                        <div v-if="bookingStatus!='FailedPage'" class="container-title">
                            {{$t("bookingStatus.bookingDet")}}
                        </div>


                        <div class="row">
                            <div v-if="bookingStatus!='FailedPage'" class="col-md-6">
                                <div class="content-section">
                            <span v-if="orderDetails && orderDetails.data && orderDetails.data.orderID">
                                {{$t("bookingStatus.bookResId")}}
                            </span>
                                    <span>
                                {{orderDetails && orderDetails.data && orderDetails.data.orderID}}
                            </span>
                                </div>
                            </div>
                            <div v-if="orderDetails && orderDetails.data && orderDetails.data.pnr.length!=0"
                                 class="col-md-6">
                                <div class="content-section">
                            <span>
                            {{$t("bookingStatus.pnr")}}
                            </span>
                                    <span v-if="orderDetails && orderDetails.data && orderDetails.data.pnr">
                                {{orderDetails.data.pnr.toString().replace(/,/g, ", ")}}
                            </span>

                                </div>
                            </div>

                            <!-- (No need to Ticketing Deadline orderId for SuccessPage) -->
                            <div v-if="bookingStatus!='SuccessPage'" class="col-md-6">
                                <div class="content-section">
                            <span>
                               {{$t("bookingStatus.tickDeadLine")}}
                            </span>
                                    <span>
                                {{orderDetails && orderDetails.data && orderDetails.data.ticketingDeadline  | formatDateTimeTZ(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                            </span>
                                </div>
                            </div>

                            <!-- (have to show Ticket number for SuccessPage) -->
                            <div v-if="bookingStatus=='SuccessPage'" class="col-md-6">
                                <div v-if="ticketNo && ticketNo.length!=0" class="content-section">
                            <span>
                               {{$t("bookingStatus.ticktNum")}}
                            </span>
                                    <span v-if="ticketNo">
                                {{ticketNo.toString().replace(/,/g, ", ")}}
                            </span>

                                </div>

                                <div v-if="!ticketNo || (ticketNo && ticketNo.length==0)" class="content-section">
                            <span>
                               {{$t("bookingStatus.ticktNum")}}
                            </span>
                             <!-- <span v-if="apiCallCount<3" class="text-load-ani thankyou-loading-text">
                                    <div class="loading loading01">
                                        <span>L</span>
                                        <span>o</span>
                                        <span>a</span>
                                        <span>d</span>
                                        <span>i</span>
                                        <span>n</span>
                                        <span>g</span>
                                        <span>.</span>
                                        <span>.</span>
                                    </div>
                               </span> -->
                               <span v-if="apiCallCount>=3" >
                                    <div >
                                        <span>{{$t("bookingStatus.ticketIssuedShortly")}}</span>
                                        
                                    
                                    </div>
                               </span>

                                </div>
                            </div>
                        </div>
                        <div class="cta-seaction">
                            <button @click="navigateToSearch()" class="general-btn success">
                                {{$t("bookingStatus.backToHome")}}
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            <section v-if="bookingStatus!='FailedPage'" class="bk-details">
                <div class="sec-title">
                    {{$t("bookingStatus.flightDet")}}
                </div>
                <div v-if="orderDetails && orderDetails.data" class="content">
                    <div class="fl-details">
                        <div v-for="(orderItems,oindex) in flightLs"
                             :key="'OItem'+oindex" class="wrapper">

                            <div @click="orderItems.flightInfo.toShowConnectingInfo=!orderItems.flightInfo.toShowConnectingInfo" v-if="orderItems.flightInfo.obFlight" class="sec-wrapper">
                                <div class="date">{{orderItems.flightInfo.obFlight[0].flight.DepDate | formatDate("dddd, DD MMM, YYYY ") }}- Depart
                                </div>
                                <div id="flight-result-wrapper">
                                    <div class="individual-flight">
                                        <div data-v-0052d509="" class="card info-flight">
                                            <div class="main-info-wrap">
                                                <div class="info-wrap">
                                                    <div class="time-place-wrap">
                                                        <div class="left">
                                                            <div class="place-code">{{orderItems.flightInfo.obFlight[0].flight.DepAirport}}</div>
                                                            <div class="time">{{orderItems.flightInfo.obFlight[0].flight.DepDate |
                                                                formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT) }}</div>
                                                            <div class="place">{{orderItems.flightInfo.obFlight[0].flight.DepAirport |
                                                                cityName}}</div>
                                                        </div>
                                                        <div class="center"><img class="rotate-90 h-33px" src="@imgPath/img/svg/icons/blue-icons/flight-dark-blue.svg" alt="">
                                                        </div>
                                                        <div class="right">
                                                            <div class="place-code">{{orderItems.flightInfo.obFlight[orderItems.flightInfo.obFlight.length-1].flight.ArrAirport}}</div>
                                                            <div class="time">{{orderItems.flightInfo.obFlight[orderItems.flightInfo.obFlight.length-1].flight.ArrDate |
                                                                formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT) }}<span class="day"></span></div>
                                                            <div class="place">{{orderItems.flightInfo.obFlight[orderItems.flightInfo.obFlight.length-1].flight.ArrAirport |
                                                                cityName}}</div>
                                                        </div>
                                                    </div>
                                                                                                            
                                                    <div class="flight-name">
                                                         
                                                         
                                                        <div class="logo" v-if="airlines && orderItems  ">
                                                           
                                                            <img
                                                                    :src="airlines[orderItems.flightInfo.obFlight[0].flight.opAirline].logourl||defaultALImg">
                                                        </div>
                                                        <div class="logo" v-else><img
                                                                :src="defaultALImg">
                                                        </div>
                                                        <div class="name">
                                                            <div class="t-flight-name">
                                                                <!-- {{orderItems.flightInfo.obFlight[0].flight.opAirline
                                                                |airlineName}} -->
                                                                {{airlines[orderItems.flightInfo.obFlight[0].flight.opAirline].airline_name}}
                                                            </div>
                                                            <span class="flight-code">{{orderItems.flightInfo.obFlight[0].flight.FlightNo}} | Class {{orderItems.flightInfo.obFlight[0].flight.Bookingclass}} 
                                                                |   
                                                            <span v-if="!isStopsForNonMyanmar"
                              class="stop"
                        >{{orderItems.flightInfo.obFlight && orderItems.flightInfo.obFlight[0].flight.no_of_stops && orderItems.flightInfo.obFlight[0].flight.no_of_stops}}</span>
                        <span v-else-if="isStopsForNonMyanmar && orderItems.flightInfo.obFlight.length==1"
                                class="via"
                        >{{orderItems.flightInfo.obFlight && orderItems.flightInfo.obFlight[0] && orderItems.flightInfo.obFlight[0].flight.Via_Obj}}</span>
                        <span v-else-if="isStopsForNonMyanmar && orderItems.flightInfo.obFlight.length>1"
                                class="via"
                        ><span>{{orderItems.flightInfo.obFlight && orderItems.flightInfo.obFlight[0] && orderItems.flightInfo.obFlight[0].flight.no_of_stops && orderItems.flightInfo.obFlight[0].flight.no_of_stops}}</span>
                <span >{{orderItems.flightInfo.obFlight[0].flight.Via_Obj != 'Non-Stop'?'| '+orderItems.flightInfo.obFlight[0].flight.Via_Obj:null}}</span></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="luggage d-flex">
                                                        <div class="d-flex mr-auto">
                                                            <img src="@imgPath/img/svg/icons/clock.svg" alt="">
                                                            <span>{{orderItems.flightInfo.obFlight[0].flight.TotalDuration |convertToHrMin("minutes","H [h] mm [m]")}}</span>
                                                        </div>
                                                        <div v-if="orderItems.flightInfo.obFlight[0].flight.baggage" class="d-flex mr-auto back">
                                                            <img src="@imgPath/img/svg/icons/Suitcase_icon.svg"
                                                                 alt="">
                                                            <span class="back-c">{{orderItems.flightInfo.obFlight[0].flight.baggage[0].weightinkg+' Kg'}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            <cConnectingFlightInfo v-if="orderItems.flightInfo.toShowConnectingInfo" 
                              :flightClass="orderItems.flightInfo.obFlight[0].flight.Bookingclass"  :flightObject="orderItems.flightInfo.obFlight"></cConnectingFlightInfo>

                            </div>
                            <div @click="orderItems.flightInfo.toShowConnectingInfo=!orderItems.flightInfo.toShowConnectingInfo" v-if="orderItems.flightInfo.ibFlight" class="sec-wrapper">
                                <div class="date">{{orderItems.flightInfo.ibFlight[0].flight.ArrDate | formatDate("dddd, DD MMM, YYYY ") }}- Return
                                </div>
                                <div id="flight-result-wrapper">
                                    <div class="individual-flight">
                                        <div data-v-0052d509="" class="card info-flight">
                                            <div class="main-info-wrap">
                                                <div class="info-wrap">
                                                    <div class="time-place-wrap">
                                                        <div class="left">
                                                            <div class="place-code">
                                                                {{orderItems.flightInfo.ibFlight[0].flight.DepAirport}}
                                                            </div>
                                                            <div class="time">
                                                                {{orderItems.flightInfo.ibFlight[0].flight.DepDate |
                                                                formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT) }}
                                                            </div>
                                                            <div class="place">
                                                                {{orderItems.flightInfo.ibFlight[0].flight.DepAirport |
                                                                cityName}}
                                                            </div>
                                                        </div>
                                                        <div class="center"><img class="rotate-90 h-33px" src="@imgPath/img/svg/icons/blue-icons/flight-dark-blue.svg" alt="">
                                                        </div>
                                                        <div class="right">
                                                            <div class="place-code">
                                                                {{orderItems.flightInfo.ibFlight[orderItems.flightInfo.ibFlight.length-1].flight.ArrAirport}}
                                                            </div>
                                                            <div class="time">
                                                                {{orderItems.flightInfo.ibFlight[orderItems.flightInfo.ibFlight.length-1].flight.ArrDate |
                                                                formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT) }} <span class="day"></span></div>
                                                            <div class="place">
                                                                {{orderItems.flightInfo.ibFlight[orderItems.flightInfo.ibFlight.length-1].flight.ArrAirport |
                                                                cityName}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="flight-name">
                                                        <div class="logo" v-if="airlines && orderItems ">
                                                            <img
                                                                    :src="airlines[orderItems.flightInfo.ibFlight[0].flight.opAirline].logourl||defaultALImg">
                                                        </div>
                                                        <div class="logo" v-else><img :src="defaultALImg">
                                                        </div>
                                                        <div class="name">
                                                            <div class="t-flight-name">
                                                                <!-- {{orderItems.flightInfo.ibFlight[0].flight.opAirline
                                                                |airlineName}} -->
                                                                {{airlines[orderItems.flightInfo.ibFlight[0].flight.opAirline].airline_name}}
                                                            </div>
                                                            <span class="flight-code">{{orderItems.flightInfo.ibFlight[0].flight.FlightNo}} | Class {{orderItems.flightInfo.ibFlight[0].flight.Bookingclass}}
                                                                |<span v-if="!isStopsForNonMyanmar"
                              class="stop"
                        >{{orderItems.flightInfo.ibFlight && orderItems.flightInfo.ibFlight[0].flight.no_of_stops && orderItems.flightInfo.ibFlight[0].flight.no_of_stops}}</span>
                        <span v-else-if="isStopsForNonMyanmar && orderItems.flightInfo.ibFlight.length==1"
                                class="via"
                        >{{orderItems.flightInfo.ibFlight && orderItems.flightInfo.ibFlight[0] && orderItems.flightInfo.ibFlight[0].flight.Via_Obj}}</span>
                        <span v-else-if="isStopsForNonMyanmar && orderItems.flightInfo.ibFlight.length>1"
                                class="via"
                        ><span>{{orderItems.flightInfo.ibFlight && orderItems.flightInfo.ibFlight[0] && orderItems.flightInfo.ibFlight[0].flight.no_of_stops && orderItems.flightInfo.ibFlight[0].flight.no_of_stops}}</span>
                <span >{{orderItems.flightInfo.obFlight[0].flight.Via_Obj != 'Non-Stop'?'| '+orderItems.flightInfo.ibFlight[0].flight.Via_Obj:null}}</span></span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="luggage d-flex">
                                                        <div class="d-flex mr-auto">
                                                            <img src="@imgPath/img/svg/icons/clock.svg" alt="">
                                                            <span>{{orderItems.flightInfo.ibFlight[0].flight.TotalDuration |convertToHrMin("minutes","H [h] mm [m]")}}</span>
                                                        </div>
                                                        <div v-if="orderItems.flightInfo.ibFlight[0].flight.baggage" class="d-flex mr-auto back">
                                                            <img src="@imgPath/img/svg/icons/Suitcase_icon.svg"
                                                                 alt="">
                                                            <span class="back-c">{{orderItems.flightInfo.ibFlight[0].flight.baggage[0].weightinkg+' Kg'}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            <cConnectingFlightInfo v-if="orderItems.flightInfo.toShowConnectingInfo"
                                :flightClass="orderItems.flightInfo.ibFlight[0].flight.Bookingclass" :flightObject="orderItems.flightInfo.ibFlight"></cConnectingFlightInfo>

                            </div>
                        </div>
                    </div>

                    <div class="ps-details">
                        <div class="sub-t text-center">
                            {{$t("bookingStatus.paxDet")}}
                        </div>

                        <div v-for="(paxItems,paxindex) in paxList"
                             :key="'paxItem'+paxindex" class="pass-details">
<!--                            <div v-if="paxItems.gender==1" class="img">-->
<!--                                <img src="@imgPath/img/svg/icons/male.svg" alt="">-->
<!--                            </div>-->
<!--                            <div v-if="paxItems.gender==2" class="img">-->
<!--                                <img src="@imgPath/img/svg/icons/female.svg" alt="">-->
<!--                            </div>-->

                                                        <div class="img" v-if="paxItems.paxType === 'CHD'">
                                                            <img src="@imgPath/img/svg/icons/child.svg" alt="">
                                                        </div>
                                                        <div class="img"  v-if="paxItems.paxType === 'INF'">
                                                            <img src="@imgPath/img/svg/icons/infant.svg" alt="">
                                                        </div>
                                                        <div class="img" v-if="paxItems.paxType === 'ADT'">
                                                            <img src="@imgPath/img/svg/icons/male.svg" alt="">
                                                        </div>
                            <div class="text">
                                <div class="name">
                                    {{paxItems.title+' '+paxItems.firstName+' '+paxItems.lastName}}
                                </div>
                                <div class="type">
                                    {{paxItems.paxType=='ADT'?$t("bookingStatus.adult"):paxItems.paxType=='CHD'?$t("bookingStatus.child"):$t("bookingStatus.infant")}}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div v-if="orderDetails && orderDetails.data &&
                     orderDetails.data.priceDetails" class="payment-details">
                        <div class="block">
                            <div class="nor">
                                {{$t("bookingStatus.payDet")}}
                            </div>
                            <div v-if="orderDetails && orderDetails.data && orderDetails.data.priceDetails && orderDetails.data.priceDetails.paymentMethodLogoURL"
                                 class="py-mth-logo">
                                <img :src="orderDetails.data.priceDetails.paymentMethodLogoURL||defaultALImg">
                            </div>
                        </div>
                        <div class="block">
                            <div class="title">
                                {{$t("bookingStatus.totCharge")}}
                            </div>
                            <div class="price">{{orderDetails.data.priceDetails.currency +' '}}
                                {{orderDetails.data.priceDetails.total |
                                amountformat(orderDetails.data.priceDetails.currency)}}
                            </div>
                        </div>
                        <div class="block">
                            <div class="title">
                                {{$t("bookingStatus.fareBreak")}}
                            </div>
                            <div class="total">
                                <table>
                                    <tbody>
                                    <tr>
                                        <td>
                                            {{$t("bookingStatus.baseFare")}}
                                        </td>
                                        <td>
                                            {{orderDetails.data.priceDetails.currency }}
                                        </td>
                                        <td>
                                            {{orderDetails.data.priceDetails.baseFare |
                                            amountformat(orderDetails.data.priceDetails.currency)}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {{$t("bookingStatus.tax")}}
                                        </td>
                                        <td>
                                            {{orderDetails.data.priceDetails.currency}}
                                        </td>
                                        <td>
                                            {{orderDetails.data.priceDetails.tax |
                                            amountformat(orderDetails.data.priceDetails.currency)}}
                                        </td>
                                    </tr>
                                    <tr v-if="orderDetails.data.priceDetails.fee!=0">
                                        <td>
                                            {{$t("bookingStatus.fees")}}
                                        </td>
                                        <td>
                                            {{orderDetails.data.priceDetails.currency }}
                                        </td>
                                        <td>
                                            {{orderDetails.data.priceDetails.fee |
                                            amountformat(orderDetails.data.priceDetails.currency)}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            {{$t("bookingStatus.total")}}
                                        </td>
                                        <td>
                                            {{orderDetails.data.priceDetails.currency}}
                                        </td>
                                        <td>
                                            {{orderDetails.data.priceDetails.total |
                                            amountformat(orderDetails.data.priceDetails.currency)}}
                                        </td>
                                    </tr>


                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>

            </section>


        </div>
        <!-- <cAlertModal
      :show="isAlert"
      :status="0"
      :buttonList="navToSearch()"
      :desc="alertValue"
    ></cAlertModal> -->
    </div>
</template>

<script>
    import BaseConfiguration from "../../config/base.js";
    import {mapGetters, mapActions} from "vuex";
    import router, {navigateReplace, goBack} from "../../router/index";
    import {COMPONENT_NAME, PATHNAME, ROUTER_PARAM,DATE_TIME_FORMAT, PAYMENT_PROCEED_TO} from "../../util/constants.js";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../config/API_DATA";
    import Vue from 'vue';
    //import { ContentLoader } from "vue-content-loader";
    import Logger from "../../services/logger";
    import cConnectingFlightInfo from "../result/cConnectingFlightInfo"
import { cloneDeep } from '../../util/util';
    export const bus = new Vue();
    export default {
        data: () => ({
            defaultALImg: BaseConfiguration.defaultALImg,
            orderDetails: null,
            isAlert: false,
            apiCallCount:0,
            alertValue: null,
            paxList: [],
            flightLs: [],
            airlines: null,
            ticketNo: [],
            isStopsForNonMyanmar : BaseConfiguration.isStopsForNonMyanmar
        }),
         components: {
             cConnectingFlightInfo
         },
        props: {
            bookingStatus: {
                type: String

            },
            


        },
        computed: {
             DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
            ...mapGetters("sPaymentPage", {
                GET_ORDER_DETAIL_RES: "GET_ORDER_DETAIL_RES",
                GET_ORDER_DETAIL_SIGNEDIN_RES: "GET_ORDER_DETAIL_SIGNEDIN_RES"
            }),
            ...mapGetters("sResult", {
                GET_AIRLINES: 'GET_AIRLINES',

            }),
            ...mapGetters("sMLResult", {
                GET_ML_AIRLINES: 'GET_ML_AIRLINES',

            }),
        },
        methods: {


            navigateToSearch() {

                try {
                    if (BaseConfiguration.isDebug) console.log("navigateToSearch");

                    navigateReplace(PATHNAME.FLIGHTSEARCH);

                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_BOOKINGSTATUS,
                        "error in navigateToSearch",
                        err.toString(),
                        "navigateToSearch",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            updateTicketNo(pTicketNumber) {
                this.ticketNo = pTicketNumber;
            },

            getApiCallCount(pApiCallCount){
                this.apiCallCount = pApiCallCount;
            },

            toGetCalculatedFlightDetails(pFlightLs) {
                let retValue;
                try {
                  if(BaseConfiguration.isDebug) console.log("toGetCalculatedFlightDetails");
                  
                  if(pFlightLs.length!=0){
                      for (let i = 0; i < pFlightLs.length; i++) {
                    
                         if(pFlightLs[i].flightInfo.obFlight){
                              pFlightLs[i].flightInfo.obFlight[0].flight["no_of_stops"] = pFlightLs[i].flightInfo.obFlight.length-1 == 0 ?
                        this.$t('flightResults.nonstop') : pFlightLs[i].flightInfo.obFlight.length-1 == 1
                        ? pFlightLs[i].flightInfo.obFlight.length-1 + ' '+this.$t('flightResults.stop')
                        : pFlightLs[i].flightInfo.obFlight.length-1 > 1 ? pFlightLs[i].flightInfo.obFlight.length-1 + ' '+this.$t('flightResults.stops') :null;

                             pFlightLs[i].flightInfo.obFlight[0].flight["TotalDuration"]=0
                             pFlightLs[i].flightInfo.obFlight[0].flight["Via_Obj"] = "";
                             pFlightLs[i].flightInfo.obFlight = this.assignFlightProp(pFlightLs[i].flightInfo.obFlight);

                             if(pFlightLs[i].flightInfo.obFlight.length>1){
                                pFlightLs[i].flightInfo["toShowConnectingInfo"]=true; 
                             }
                           
                         }
                        
                         if(pFlightLs[i].flightInfo.ibFlight ){
                             pFlightLs[i].flightInfo.ibFlight[0].flight["no_of_stops"] = pFlightLs[i].flightInfo.ibFlight.length-1 == 0 ?
                        this.$t('flightResults.nonstop') : pFlightLs[i].flightInfo.ibFlight.length-1 == 1
                        ? pFlightLs[i].flightInfo.ibFlight.length-1 + ' '+this.$t('flightResults.stop')
                        : pFlightLs[i].flightInfo.ibFlight.length-1 > 1 ? pFlightLs[i].flightInfo.ibFlight.length-1 + ' '+this.$t('flightResults.stops') :null;

                             pFlightLs[i].flightInfo.ibFlight[0].flight["Via_Obj"] = "";
                             pFlightLs[i].flightInfo.ibFlight[0].flight["TotalDuration"]=0
                             pFlightLs[i].flightInfo.ibFlight = this.assignFlightProp(pFlightLs[i].flightInfo.ibFlight);

                              if(pFlightLs[i].flightInfo.ibFlight.length>1){
                                pFlightLs[i].flightInfo["toShowConnectingInfo"]=true; 
                             }
                         }
                      }
                  }
            retValue = pFlightLs;
                } catch (err) {
                        let body = Logger.buildRequest(
                          FILE_NAME.C_BOOKINGSTATUS,
                          "error in toGetCalculatedFlightDetails",
                          err.toString(),
                          "toGetCalculatedFlightDetails",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
            }, 

   
    assignFlightProp(pFlightList) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("assignFlightProp");
          for (let j = 0; j < pFlightList.length; j++) {

              pFlightList[0].flight.TotalDuration += pFlightList[j].flight.DurationInMin;

            if(pFlightList[j].flight.via && pFlightList[j].flight.via!=null && pFlightList[j].flight.via.text && 
              pFlightList[j].flight.via.text!=null) {
                if(j==0){
                  pFlightList[0].flight.Via_Obj+=pFlightList[j].flight.via.text;
                }else{
             pFlightList[0].flight.Via_Obj+="," + pFlightList[j].flight.via.text.replace('Via',"");
                }
              }
          }
         if(pFlightList[0].flight.Via_Obj==null || pFlightList[0].flight.Via_Obj==""){
            pFlightList[0].flight.Via_Obj=this.$t('flightResults.nonstop');
          }
          retValue = pFlightList;
       
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_BOOKINGSTATUS,
          "error in assignFlightProp",
          err.toString(),
          "assignFlightProp",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }

        },

        mounted() {
            this.$root.$on("gotApiCallCount",(pApiCallCount) => {
                this.getApiCallCount(pApiCallCount);
            });

            this.$root.$on("gotTickerNumber", (pTicketNumber) => {
                this.updateTicketNo(pTicketNumber);
                if (BaseConfiguration.isDebug) console.log("gotTickerNumber----Received!");
            });
        },

        created() {
            try {
                if (BaseConfiguration.isDebug) console.log("created");

                if (this.GET_AIRLINES != null) {
                    this.airlines = this.GET_AIRLINES;
                    
                } else if (this.GET_ML_AIRLINES) {
                    this.airlines = this.GET_ML_AIRLINES;
                }
                if (this.GET_ORDER_DETAIL_RES != null) {

                    this.orderDetails = this.GET_ORDER_DETAIL_RES;
                    if (this.orderDetails && this.orderDetails.data &&
                        this.orderDetails.data.ticketNumbers &&
                        this.orderDetails.data.ticketNumbers.length) {
                        this.updateTicketNo(this.orderDetails.data.ticketNumbers);
                    }
                } else if (this.GET_ORDER_DETAIL_SIGNEDIN_RES != null) {

                    this.orderDetails = this.GET_ORDER_DETAIL_SIGNEDIN_RES;
                    if (this.orderDetails && this.orderDetails.data &&
                        this.orderDetails.data.ticketNumbers &&
                        this.orderDetails.data.ticketNumbers.length) {
                        this.updateTicketNo(this.orderDetails.data.ticketNumbers);
                    }
                }
                if(this.airlines==null){

                this.airlines = this.orderDetails.data.airlines;
                }
                // this.paxList=this.orderDetails.data.passengerDetails.reverse()
                let tempLs = [];
                if (this.orderDetails && this.orderDetails.data && this.orderDetails.data.passengerDetails) {
                    for (let index = 0; index < this.orderDetails.data.passengerDetails.length; index++) {
                        if (this.orderDetails.data.passengerDetails[index].isLeadPax == true) {
                            this.paxList.push(this.orderDetails.data.passengerDetails[index]);
                        } else {
                            tempLs.push(this.orderDetails.data.passengerDetails[index])
                        }
                    }
                }

                var ordLs=[];

                tempLs.filter(aobj => {
                if(aobj.paxType=='ADT'){
                    ordLs.push(aobj);
                    }
                    });
                tempLs.filter(aobj => {
                if(aobj.paxType=='CHD'){
                    ordLs.push(aobj);
                    }
                    });
                 tempLs.filter(aobj => {
                if(aobj.paxType=='INF'){
                    ordLs.push(aobj);
                    }
                    });

                for (let i = 0; i < ordLs.length; i++) {
                        this.paxList.push(ordLs[i]);
                }

                let tempFlightLs = [];
                if (this.orderDetails && this.orderDetails.data && this.orderDetails.data.orderItems) {
                    for (let index = 0; index < this.orderDetails.data.orderItems.length; index++) {
                        if (this.orderDetails.data.orderItems[index].flightInfo.obFlight) {
                            this.flightLs.push(this.orderDetails.data.orderItems[index]);
                        } else {
                            tempFlightLs.push(this.orderDetails.data.orderItems[index])
                        }
                    }
                }

                if(tempFlightLs.length!=0) {
                for (let i = 0; i < tempFlightLs.length; i++) {
                    this.flightLs.push(tempFlightLs[i]);
                    let flights = this.toGetCalculatedFlightDetails(this.flightLs);
                    this.flightLs = cloneDeep(flights);

                }
                }else{
                  for (let i = 0; i < this.flightLs.length; i++) {
                    
                    let flights = this.toGetCalculatedFlightDetails(this.flightLs);
                    this.flightLs = cloneDeep(flights);

                }  
                }

                




                // this.$root.$emit("toggle-sidebar", true);

            } catch (err) {
                let body = Logger.buildRequest(
                    FILE_NAME.C_BOOKINGSTATUS,
                    "error in created",
                    err.toString(),
                    "created",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }

        },


    }
</script>
<style>

    /* html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper, html:not([dir="rtl"]) .c-sidebar.c-sidebar-show:not(.c-sidebar-right).c-sidebar-fixed ~ .c-wrapper {
        margin: 0px !important;
    }

    html:not([dir="rtl"]) .c-sidebar.c-sidebar-lg-show:not(.c-sidebar-right), html:not([dir="rtl"]) .c-sidebar.c-sidebar-show:not(.c-sidebar-right) {
        display: none;
    } */

</style>

